import { render } from "./FilterTooltip.vue?vue&type=template&id=1b63422a"
import script from "./FilterTooltip.vue?vue&type=script&lang=js"
export * from "./FilterTooltip.vue?vue&type=script&lang=js"
script.render = render

export default script